import { AxiosResponse } from "axios";
import { api } from "../base/api";
import { IBodyshopApi } from "../base/registration/bodyshopApi";
import { KeyValue } from "../../models/common";
import { BodyShopFilterRequest, BodyShopSaveRequest } from "../../models/request/bodyshopRequest";
import {
	BodyshopRegistrationBranchResponse,
	BodyshopRegistrationDataResponse,
	BodyshopResponse,
	BodyshopSaveResponse,
} from "../../models/response";
import { Result } from "../../models/common/resultResponse";

const baseRoute: string = "Bodyshop";
export class BodyshopApi extends IBodyshopApi {
	getBodyshopsOrBodyshopBranchesDomain(request: BodyShopFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}

	getSearchGrid(request: BodyShopFilterRequest): Promise<AxiosResponse<BodyshopResponse>> {
		return api.get(`${baseRoute}`, { params: request });
	}

	getRegistrationDataBodyshopBranch(
		request: BodyShopFilterRequest,
	): Promise<AxiosResponse<Result<BodyshopRegistrationBranchResponse[]>>> {
		return api.get(`${baseRoute}/bodyshopbranch`, { params: request });
	}

	getRegistrationDataBodyshop(
		request: BodyShopFilterRequest,
	): Promise<AxiosResponse<Result<BodyshopRegistrationDataResponse>>> {
		return api.get(`${baseRoute}/getbodyshopregistrationdata`, {
			params: request,
		});
	}

	saveBodyshop(request: BodyShopSaveRequest): Promise<AxiosResponse<Result<BodyshopSaveResponse>>> {
		return api.post(`${baseRoute}/save`, request);
	}
}
